import { z } from 'zod';

export interface OneTimeSchedule {
    type: 'OneTimeSchedule';
    dateTime: string;
}

export type ScheduleUnit = 'MINUTE' | 'HOUR' | 'DAY' | 'WEEK' | 'MONTH' | 'YEAR';

export interface RecurringRateBasedSchedule {
    type: 'RecurringRateBasedSchedule';
    unit: ScheduleUnit;
    value: number;
}

export interface RecurringCronBasedSchedule {
    type: 'RecurringCronBasedSchedule';
    cronExpression: string;
}

export type ScheduleExpression = OneTimeSchedule | RecurringRateBasedSchedule | RecurringCronBasedSchedule;

export function formatRecurringRateBasedSchedule(schedule: RecurringRateBasedSchedule): string {
    if (schedule.value === 1) {
        return `Every ${getScheduleUnitLabel(schedule.unit)}`;
    } else {
        return `Every ${schedule.value} ${getScheduleUnitLabel(schedule.unit)}s`;
    }
}

export function getScheduleUnitLabel(unit: ScheduleUnit): string {
    switch (unit) {
        case 'MINUTE':
            return 'Minute';
        case 'HOUR':
            return 'Hour';
        case 'DAY':
            return 'Day';
        case 'WEEK':
            return 'Week';
        case 'MONTH':
            return 'Month';
        case 'YEAR':
            return 'Year';
    }
}

export const OneTimeScheduleSchema = z.object({
    type: z.literal('OneTimeSchedule'),
    dateTime: z.string(),
});

export const ScheduleUnitSchema = z.union([
    z.literal('MINUTE'),
    z.literal('HOUR'),
    z.literal('DAY'),
    z.literal('WEEK'),
    z.literal('MONTH'),
    z.literal('YEAR'),
]);

export const RecurringRateBasedScheduleSchema = z.object({
    type: z.literal('RecurringRateBasedSchedule'),
    unit: ScheduleUnitSchema,
    value: z.number(),
});

export const RecurringCronBasedScheduleSchema = z.object({
    type: z.literal('RecurringCronBasedSchedule'),
    cronExpression: z.string(),
});

export const ScheduleExpressionSchema = z.discriminatedUnion('type', [
    OneTimeScheduleSchema,
    RecurringRateBasedScheduleSchema,
    RecurringCronBasedScheduleSchema,
]);
